module.exports = __webpack_public_path__ + "img/Group 10277.4603d5e3.svg";